import { NgModule, DoBootstrap, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import { setAngularJSGlobal, UpgradeModule } from '@angular/upgrade/static';
import * as angular from 'angular';

import { GoModulesModule } from '@go-modules/go-modules.module';
import { InterceptorsModule } from '@go-modules/services/interceptors';
import { DashboardModule } from '@go-modules/components/dashboard/dashboard.module';
import { LoadingModule } from '@go-modules/components/loading/loading.module';

import { SuperBarModule } from '@dashboard/app/components/super-bar/super-bar.module';
import { NgxFoldersViewModule } from '@dashboard/app/components/folders-view/folders-view.module';
import { SignupModule } from '@dashboard/app/components/signup/signup.module';
import { AppComponent } from './app.component';
import { dashboardLegacyModule } from './legacy/dashboard-legacy.module';
import { PWAInstallPromptModule } from '@dashboard/app/components/pwa-install-prompt/pwa-install-prompt.module';
import { MatDialogConfig, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { GoLocalizeHelperService, Language } from 'go-modules/translation-helper/go-localize-helper.service';
import { environment } from '@dashboard/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { GoToastModule } from '@go-modules/components/go-toast/go-toast.module';
import { DashboardTitleStrategy } from './dashboard-title.strategy';

@NgModule({ declarations: [
	AppComponent
], imports: [BrowserModule,
	AppRoutingModule,
	UpgradeModule,
	TranslateModule.forRoot({
		fallbackLang: 'en',
		loader: provideTranslateHttpLoader({
			prefix: `${environment.translationsPrefix}translations/translation/`
		})
	}),
	GoModulesModule, // This needs to slowly be replaced by real components modules depending on correct things
	InterceptorsModule,
	BrowserAnimationsModule,
	DashboardModule,
	LoadingModule,
	NgxFoldersViewModule,
	SignupModule,
	SuperBarModule,
	GoToastModule,
	PWAInstallPromptModule
], providers: [
	{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {
		...new MatDialogConfig(),
		maxWidth: ''
	} },
	{ provide: '$scope', useExisting: '$rootScope' },
	{
		provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
		useValue: { appearance: 'outline' }
	},
	{ provide: TitleStrategy, useClass: DashboardTitleStrategy },
	provideHttpClient(withInterceptorsFromDi())
] })
export class AppModule implements DoBootstrap {
	constructor (private upgrade: UpgradeModule) { }

	public ngDoBootstrap (app: ApplicationRef): void {
		setAngularJSGlobal(angular);
		const injector: ng.auto.IInjectorService = this.upgrade.bootstrap(document.body, [
			dashboardLegacyModule
		]);
		const localizeHelper: GoLocalizeHelperService = injector.get('goLocalizeHelper');
		localizeHelper.configure(Language.EN).then(() => {
			app.bootstrap(AppComponent);
		});
	}
}
